import { z } from 'zod'

const jsonObject = z.record(z.unknown())

export const tcpcatalog3putPutCatalogDraftsCurrentUseCasesUseCaseKeyResponseSchema = jsonObject
export type tcpcatalog3putPutCatalogDraftsCurrentUseCasesUseCaseKeyResponse = z.infer<typeof tcpcatalog3putPutCatalogDraftsCurrentUseCasesUseCaseKeyResponseSchema>
